import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "flex max-h-[92vh] flex-col overflow-hidden rounded-2xl bg-slate-100 shadow-2xl"
};
const _hoisted_2 = {
  class: "flex items-center justify-between border-b border-slate-200 bg-white px-5 py-3"
};
const _hoisted_3 = {
  class: "mt-0.5 text-xs text-slate-500"
};
const _hoisted_4 = {
  class: "flex items-start justify-center overflow-auto p-6"
};
const _hoisted_5 = {
  class: "mp-q-section"
};
const _hoisted_6 = {
  class: "mp-q-title"
};
const _hoisted_7 = {
  class: "mp-a-section"
};
const _hoisted_8 = {
  class: "mp-a-body"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  key: 0,
  class: "mp-stats-row"
};
const _hoisted_11 = {
  key: 0,
  class: "mp-stat-item"
};
const _hoisted_12 = {
  class: "mp-stat-text"
};
const _hoisted_13 = {
  key: 1,
  class: "mp-stat-item"
};
const _hoisted_14 = {
  class: "mp-stat-text"
};
const _hoisted_15 = {
  class: "mp-feedback-section"
};
const _hoisted_16 = {
  class: "mp-feedback-btn"
};
const _hoisted_17 = {
  class: "mp-feedback-count"
};
const _hoisted_18 = {
  class: "mp-feedback-btn"
};
const _hoisted_19 = {
  class: "mp-feedback-count"
};
const _hoisted_20 = {
  key: 0,
  class: "mp-related-section"
};
const _hoisted_21 = {
  class: "mp-related-list"
};
const _hoisted_22 = {
  class: "mp-related-text"
};
const _hoisted_23 = {
  class: "mp-policy-title-section"
};
const _hoisted_24 = {
  class: "mp-title-row"
};
const _hoisted_25 = {
  class: "mp-policy-title"
};
const _hoisted_26 = {
  key: 0,
  class: "mp-tags-wrap"
};
const _hoisted_27 = {
  class: "mp-meta-tag-text mp-status-text"
};
const _hoisted_28 = {
  key: 1,
  class: "mp-meta-tag"
};
const _hoisted_29 = {
  class: "mp-meta-tag-text"
};
const _hoisted_30 = {
  key: 1,
  class: "mp-tags-wrap"
};
const _hoisted_31 = {
  key: 0,
  class: "mp-meta-tag"
};
const _hoisted_32 = {
  class: "mp-meta-tag-text"
};
const _hoisted_33 = {
  key: 1,
  class: "mp-meta-tag"
};
const _hoisted_34 = {
  class: "mp-meta-tag-text"
};
const _hoisted_35 = {
  key: 2,
  class: "mp-meta-tag"
};
const _hoisted_36 = {
  class: "mp-meta-tag-text"
};
const _hoisted_37 = {
  class: "mp-policy-content-section"
};
const _hoisted_38 = ["innerHTML"];
const _hoisted_39 = {
  key: 0,
  class: "mp-attach-section"
};
const _hoisted_40 = {
  class: "mp-attach-list"
};
const _hoisted_41 = {
  class: "mp-file-left"
};
const _hoisted_42 = {
  class: "mp-file-info"
};
const _hoisted_43 = {
  class: "mp-file-name"
};
const _hoisted_44 = {
  class: "mp-file-size"
};
import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getFaqItemDetail, getPolicyRegulationDetail } from '@/api/kb';
import MpPhoneFrame from '@/components/MpPhoneFrame.vue';
export default {
  __name: 'KbDetailPreviewModal',
  props: {
    // 控制显示
    modelValue: {
      type: Boolean,
      default: false
    },
    // 预览类型：faq（常见问题详情）/ policy（政策法规详情）
    type: {
      type: String,
      required: true,
      validator: value => ['faq', 'policy'].includes(value)
    },
    // 已保存条目：传条目ID，组件自动加载详情
    itemId: {
      type: [String, Number],
      default: null
    },
    // 编辑中未保存内容：直接传入表单快照，无需请求接口
    // faq 形状：{ title, content, tags, isTop, status }
    // policy 形状：{ title, docNumber, issuingAuthority, effectiveDate, expireDate,
    //   urgencyLevel, tags, content, attachments: [{ fileName, fileSize, fileType }] }
    previewData: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const loading = ref(false);
    const detailStatus = ref(null);
    const faqInfo = reactive({
      title: '',
      content: '',
      viewCount: null,
      updateTime: '',
      likeCount: 0,
      dislikeCount: 0,
      relatedFaqs: []
    });
    const policyInfo = reactive({
      title: '',
      status: null,
      issuingAuthority: '',
      docNumber: '',
      effectiveDate: '',
      expiryDate: '',
      content: '',
      attachments: []
    });
    const navbarTitle = computed(() => props.type === 'faq' ? '问题详情' : '政策详情');
    const policyStatusText = computed(() => ({
      0: '草稿',
      1: '现行有效',
      2: '已失效'
    })[policyInfo.status] || '');
    const policyStatusTagClass = computed(() => ({
      0: 'draft-tag',
      1: 'status-tag',
      2: 'expired-tag'
    })[policyInfo.status] || '');
    const hintText = computed(() => {
      if (props.previewData) {
        return '预览当前编辑内容（包含未保存的修改）';
      }
      if (props.type === 'faq') {
        return {
          0: '当前为草稿，发布后对外生效',
          1: '当前展示为线上生效内容',
          2: '该FAQ已归档，小程序端不可见'
        }[detailStatus.value] || '';
      }
      return {
        0: '当前为草稿，发布后对外生效',
        1: '当前展示为线上生效内容（现行有效）',
        2: '该政策已失效，小程序端展示"已失效"徽标'
      }[detailStatus.value] || '';
    });
    const close = () => emit('update:modelValue', false);

    /** 与小程序 formatFileSize 保持一致 */
    const formatFileSize = bytes => {
      if (!bytes) return '';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(0) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    };
    const isPdfFile = file => (file.fileType || '').toLowerCase() === 'pdf';

    /** 统一映射为小程序 detail 结构 */
    const fillFaq = raw => {
      detailStatus.value = raw.status ?? null;
      faqInfo.title = raw.title || '';
      faqInfo.content = raw.content || '';
      faqInfo.viewCount = raw.viewCount ?? null;
      faqInfo.updateTime = raw.updateTime || '';
      faqInfo.likeCount = raw.likeCount ?? 0;
      faqInfo.dislikeCount = raw.dislikeCount ?? 0;
      faqInfo.relatedFaqs = Array.isArray(raw.relatedFaqs) ? raw.relatedFaqs : [];
    };
    const fillPolicy = raw => {
      detailStatus.value = raw.status ?? null;
      policyInfo.title = raw.title || '';
      policyInfo.status = raw.status ?? null;
      policyInfo.issuingAuthority = raw.issuingAuthority || '';
      policyInfo.docNumber = raw.docNumber || '';
      policyInfo.effectiveDate = raw.effectiveDate || '';
      policyInfo.expiryDate = raw.expiryDate || raw.expireDate || '';
      policyInfo.content = raw.content || '';
      policyInfo.attachments = Array.isArray(raw.attachments) ? raw.attachments : [];
    };
    const loadDetail = async () => {
      loading.value = true;
      try {
        let data;
        if (props.type === 'faq') {
          data = await getFaqItemDetail(props.itemId);
          fillFaq(data || {});
        } else {
          data = await getPolicyRegulationDetail(props.itemId);
          fillPolicy(data || {});
        }
      } catch (error) {
        console.error('loadKbPreview failed:', error);
        ElMessage.error(error.message || '加载详情失败');
      } finally {
        loading.value = false;
      }
    };
    watch(() => props.modelValue, visible => {
      if (!visible) return;
      detailStatus.value = null;
      if (props.previewData) {
        if (props.type === 'faq') {
          fillFaq(props.previewData);
        } else {
          fillPolicy(props.previewData);
        }
      } else if (props.itemId) {
        loadDetail();
      }
    });
    return (_ctx, _cache) => {
      return __props.modelValue ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4",
        onClick: _withModifiers(close, ["self"])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_cache[0] || (_cache[0] = _createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "小程序预览", -1)), _createElementVNode("p", _hoisted_3, _toDisplayString(hintText.value), 1)]), _createElementVNode("button", {
        onClick: close,
        class: "rounded-full p-1 text-slate-400 hover:text-slate-600",
        "aria-label": "关闭预览"
      }, [...(_cache[1] || (_cache[1] = [_createElementVNode("svg", {
        class: "h-5 w-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      })], -1)]))])]), _createElementVNode("div", _hoisted_4, [_createVNode(MpPhoneFrame, {
        title: navbarTitle.value,
        loading: loading.value,
        "content-bg": "#f6f6f8"
      }, {
        default: _withCtx(() => [__props.type === 'faq' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", _hoisted_5, [_cache[2] || (_cache[2] = _createElementVNode("span", {
          class: "mp-q-badge"
        }, "Q", -1)), _createElementVNode("span", _hoisted_6, _toDisplayString(faqInfo.title), 1), _cache[3] || (_cache[3] = _createElementVNode("span", {
          class: "mp-fav-btn"
        }, [_createElementVNode("svg", {
          class: "mp-fav-icon",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
        })])], -1))]), _createElementVNode("div", _hoisted_7, [_cache[6] || (_cache[6] = _createElementVNode("span", {
          class: "mp-a-badge"
        }, "A", -1)), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
          class: "mp-faq-content",
          innerHTML: faqInfo.content
        }, null, 8, _hoisted_9), faqInfo.viewCount !== null || faqInfo.updateTime ? (_openBlock(), _createElementBlock("div", _hoisted_10, [faqInfo.viewCount !== null ? (_openBlock(), _createElementBlock("span", _hoisted_11, [_cache[4] || (_cache[4] = _createElementVNode("span", {
          class: "mp-icon mp-icon-eye"
        }, null, -1)), _createElementVNode("span", _hoisted_12, _toDisplayString(faqInfo.viewCount) + " 阅读", 1)])) : _createCommentVNode("", true), faqInfo.updateTime ? (_openBlock(), _createElementBlock("span", _hoisted_13, [_cache[5] || (_cache[5] = _createElementVNode("span", {
          class: "mp-icon mp-icon-clock"
        }, null, -1)), _createElementVNode("span", _hoisted_14, "更新于 " + _toDisplayString(faqInfo.updateTime), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[7] || (_cache[7] = _createElementVNode("span", {
          class: "mp-icon mp-icon-like"
        }, null, -1)), _cache[8] || (_cache[8] = _createElementVNode("span", {
          class: "mp-feedback-label"
        }, "有帮助", -1)), _createElementVNode("span", _hoisted_17, _toDisplayString(faqInfo.likeCount), 1)]), _createElementVNode("div", _hoisted_18, [_cache[9] || (_cache[9] = _createElementVNode("span", {
          class: "mp-icon mp-icon-dislike"
        }, null, -1)), _cache[10] || (_cache[10] = _createElementVNode("span", {
          class: "mp-feedback-label"
        }, "没帮助", -1)), _createElementVNode("span", _hoisted_19, _toDisplayString(faqInfo.dislikeCount), 1)])]), faqInfo.relatedFaqs.length ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_cache[12] || (_cache[12] = _createElementVNode("div", {
          class: "mp-related-header"
        }, [_createElementVNode("span", {
          class: "mp-related-bar"
        }), _createElementVNode("span", {
          class: "mp-related-title"
        }, "相关问题")], -1)), _createElementVNode("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqInfo.relatedFaqs, (rq, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: rq.id || index,
            class: _normalizeClass(['mp-related-item', {
              'has-border': index < faqInfo.relatedFaqs.length - 1
            }])
          }, [_createElementVNode("span", _hoisted_22, _toDisplayString(rq.title), 1), _cache[11] || (_cache[11] = _createElementVNode("span", {
            class: "mp-icon mp-icon-chevron mp-related-arrow"
          }, null, -1))], 2);
        }), 128))])])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("span", _hoisted_25, _toDisplayString(policyInfo.title), 1), _cache[13] || (_cache[13] = _createElementVNode("span", {
          class: "mp-fav-btn"
        }, [_createElementVNode("svg", {
          class: "mp-fav-icon",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
        })])], -1))]), policyStatusText.value || policyInfo.issuingAuthority ? (_openBlock(), _createElementBlock("div", _hoisted_26, [policyStatusText.value ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(['mp-meta-tag', policyStatusTagClass.value])
        }, [_createElementVNode("span", _hoisted_27, _toDisplayString(policyStatusText.value), 1)], 2)) : _createCommentVNode("", true), policyInfo.issuingAuthority ? (_openBlock(), _createElementBlock("span", _hoisted_28, [_createElementVNode("span", _hoisted_29, "发文机关: " + _toDisplayString(policyInfo.issuingAuthority), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), policyInfo.docNumber || policyInfo.effectiveDate || policyInfo.expiryDate ? (_openBlock(), _createElementBlock("div", _hoisted_30, [policyInfo.docNumber ? (_openBlock(), _createElementBlock("span", _hoisted_31, [_createElementVNode("span", _hoisted_32, "文号: " + _toDisplayString(policyInfo.docNumber), 1)])) : _createCommentVNode("", true), policyInfo.effectiveDate ? (_openBlock(), _createElementBlock("span", _hoisted_33, [_createElementVNode("span", _hoisted_34, "生效日期: " + _toDisplayString(policyInfo.effectiveDate), 1)])) : _createCommentVNode("", true), policyInfo.expiryDate ? (_openBlock(), _createElementBlock("span", _hoisted_35, [_createElementVNode("span", _hoisted_36, "失效日期: " + _toDisplayString(policyInfo.expiryDate), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", {
          class: "mp-policy-content",
          innerHTML: policyInfo.content
        }, null, 8, _hoisted_38)]), policyInfo.attachments.length ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_cache[15] || (_cache[15] = _createElementVNode("div", {
          class: "mp-attach-header"
        }, [_createElementVNode("span", {
          class: "mp-attach-bar"
        }), _createElementVNode("span", {
          class: "mp-attach-title"
        }, "相关附件")], -1)), _createElementVNode("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(policyInfo.attachments, (file, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: file.id || index,
            class: "mp-file-card"
          }, [_createElementVNode("div", _hoisted_41, [_createElementVNode("span", {
            class: _normalizeClass(['mp-file-icon-box', isPdfFile(file) ? 'pdf' : 'doc'])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["mp-icon", isPdfFile(file) ? 'mp-icon-file' : 'mp-icon-file-text'])
          }, null, 2)], 2), _createElementVNode("span", _hoisted_42, [_createElementVNode("span", _hoisted_43, _toDisplayString(file.fileName), 1), _createElementVNode("span", _hoisted_44, _toDisplayString(formatFileSize(file.fileSize)), 1)])]), _cache[14] || (_cache[14] = _createElementVNode("span", {
            class: "mp-download-btn"
          }, [_createElementVNode("span", {
            class: "mp-download-text"
          }, "下载")], -1))]);
        }), 128))])])) : _createCommentVNode("", true)], 64))]),
        _: 1
      }, 8, ["title", "loading"])])])])) : _createCommentVNode("", true);
    };
  }
};